import { Button } from '@design-system/components/button/button';
import { Typography } from '@design-system/components/typography/typography';
import { BlockedCommunityUser } from '../model/moderation.types';

type Props = {
  user: BlockedCommunityUser;
  busy?: boolean;
  onUnblock: () => void;
};

const buildMetaLine = (user: BlockedCommunityUser): string => {
  const parts = ['Blocked', user.blockedAtLabel];
  if (user.itemsRemovedCount > 0) {
    const noun = user.itemsRemovedCount === 1 ? 'item' : 'items';
    parts.push(`${user.itemsRemovedCount} ${noun} removed`);
  }

  return parts.join(' · ');
};

export const BlockedUserCard = ({ user, busy = false, onUnblock }: Props) => (
  <div className="flex items-center justify-between gap-4 border-b border-[#EEEEEE] py-4">
    <div className="flex min-w-0 items-center gap-3">
      <img
        src={user.avatar}
        alt={user.name}
        className="h-12 w-12 shrink-0 rounded-full object-cover"
      />
      <div className="flex min-w-0 flex-col">
        <Typography
          as="span"
          variant="body"
          size="medium"
          className="font-bold"
        >
          {user.name}
        </Typography>
        <Typography
          as="span"
          variant="body"
          size="small"
          className="text-[#9E9E9E]"
        >
          {buildMetaLine(user)}
        </Typography>
      </div>
    </div>
    <Button
      color="primaryTonal"
      onClick={onUnblock}
      disabled={busy}
      className="shrink-0"
    >
      Unblock user
    </Button>
  </div>
);
